import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  InputBase,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import { rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseCustomerRetention } from "./UseCustomerRetention";
import DeleteRow from "../../components/DeleteRow";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { useLocation, useNavigate } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CalculateIcon from "@mui/icons-material/Calculate";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import CampaignReport from "./CampaignReport";
import AssessmentIcon from "@mui/icons-material/Assessment";

export default function CampaignGrid(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [campaignRes, setCampaignRes] = useState();
  const { FillCampaign, GetCampaignsList, deleteCampaign } =
    UseCustomerRetention();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [fillState, setFillState] = useState({
    id: undefined,
    discountCodeID: undefined,
    clear: false,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });

  const [openReport, setOpenReport] = useState({
    show: false,
    id: undefined,
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("Campaign");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (props.expanded === "Campaign") {
      if (
        myPc.page === 0 ||
        (location.state && location.state && location.state.isBack)
      ) {
        return;
      }
      setProgress(true);
      GetCampaignsList(
        myPc,
        search,
        (Campaign) => {
          if (msGotoLast) {
            setMsGotoLast(false);
            goToLastPage(Campaign.pageCondition.totalPage);
            return;
          }
          setCampaignRes(Campaign);
        },
        true
      );
    }
  }, [myPc, props.expanded]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/customerretention/addCampaign", {
      state: {
        myPc: myPc,
        search: search,
        expanded: props.expanded,
        patterns: props.patterns,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "paternTitle",
      headerName: "عنوان الگو",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.paternTitle}
          </Typography>
        );
      },
    },
    {
      field: "shamsiExpiredate",
      headerName: "تاریخ انقضا",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isActive ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "isExpire",
      headerName: "منقضی",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isExpire ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate(`/customerretention/editCampaign`, {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="محاسبه مشتری های کمپین">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setFillState({
                    id: cellValues.row.id,
                    discountCodeID: cellValues.row.discountCodeID,
                    clear: false,
                  });
                  setCheckState({ show: true, name: "محاسبه مشتری های کمپین" });
                }}
              >
                <CalculateIcon
                  fontSize="small"
                  sx={{ color: "MyColor.main" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="مشتری ها">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  props.setModel(cellValues.row.id);
                  props.setExpanded("results");
                }}
              >
                <PeopleAltIcon
                  fontSize="small"
                  sx={{ color: "MyColor.main" }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="گزارش">
              <IconButton
                sx={{ p: 0.5 }}
                onClick={() => {
                  setOpenReport({ show: true, id: cellValues.row.id });
                }}
              >
                <AssessmentIcon
                  fontSize="small"
                  sx={{ color: "MyColor.main" }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 230,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Accordion
      id="Campaign"
      expanded={props.expanded === "Campaign"}
      onChange={handleChange("Campaign")}
      style={{
        paddingBottom: "15px",
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            کمپین ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "25rem" }}>
          {campaignRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={campaignRes.pageCondition.pageCount}
              rows={campaignRes.campaigns}
              paginationMode="server"
              page={campaignRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                campaignRes?.pageCondition.totalItemCount
                  ? campaignRes.pageCondition.totalItemCount
                  : 0
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{ Pagination: CustomPagination }}
              componentsProps={{
                pagination: {
                  scrollTo: myPc.scrollTo,
                  newFunc: newFunc,
                  isLtr: true,
                  rowCount: campaignRes?.pageCondition.totalItemCount
                    ? campaignRes.pageCondition.totalItemCount
                    : 0,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: { page: myPc.page },
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
          <DeleteRow
            deleteState={deleteState}
            setDeleteState={setDeleteState}
            type={"کمپین "}
            callback={() => {
              setProgress(true);
              deleteCampaign(deleteState.id, () => {
                refresh();
              });
            }}
          ></DeleteRow>
          <YesOrNoDialoge
            checkState={checkState}
            setCheckState={setCheckState}
            fillState={fillState}
            setFillState={setFillState}
            callback={() => {
              setProgress(true);
              FillCampaign(fillState, (patterns) => {
                setProgress(false);
                props.setModel();
              });
            }}
          />
        </Box>
      </AccordionDetails>
      {openReport.show && (
        <CampaignReport openReport={openReport} setOpenReport={setOpenReport} />
      )}
    </Accordion>
  );
}
